import { Position, Toaster } from '@blueprintjs/core';

/** Singleton toaster instance. Create separate instances for different options. */
// eslint-disable-next-line import/prefer-default-export
export const AppToaster = Toaster.create({
  className: 'recipe-toaster',
  position: Position.TOP_RIGHT,
  usePortal: true,
});
